export default __webpack_public_path__ + "static/media/computer-background.e69b0ae7.svg";